<template>
  <div class="container">
    <div class="main" v-loading="loading">
    <div class="header">
        <div class="left">
          <div class="line-1"></div>
          <div class="line-2"></div>
          <span class="title">{{$t('complaintOrderDetail.complaintDetail')}}</span>
        </div>
        <div class="right">
          <el-button class="back-btn" icon="el-icon-back" @click="returnBack">{{$t('applyChildDetail.return')}}</el-button>
        </div>
    </div>
    <div class="content">
        <div class="row-box">
            <div class="column-box">
                <div class="topic">
                    <p class="title">{{$t('complaintOrderDetail.serviceInfo')}}</p>
                </div>
                <div class="entires">
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('complaintOrderDetail.serviceNum')}}</div>
                            <div class="con">{{ dataSource.serviceCode ? dataSource.serviceCode : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('complaintOrderDetail.serviceMember')}}</div>
                            <div class="con">{{ dataSource.serviceUser ? dataSource.serviceUser : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('editChild.contactNumber')}}</div>
                            <div class="con">{{ dataSource.servicePhone ? dataSource.servicePhone : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('complaintOrderDetail.placeOrderTime')}}</div>
                            <div class="con">{{ dataSource.createTime ? dataSource.createTime : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('complaintOrderDetail.serviceTime')}}</div>
                            <div class="con">{{ dataSource.serviceTime ? dataSource.serviceTime : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('complaintOrderDetail.comTime')}}</div>
                            <div class="con">{{ dataSource.finishTime ? dataSource.finishTime : '--' }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column-box1">
                <div class="steps">
                <el-steps :active="dataSource.status ? dataSource.status - 1 : dataSource.status " align-center :process-status="dataSource.status==0?'error':'process'">
                    <el-step
                    :title=" dataSource.status
                    ? dataSource.status > index + 1
                    ? item.checkname
                    : item.name
                    : item.name
                    "
                    v-for="(item, index) in stepsList" :key="index"
                ></el-step>
                </el-steps>
                </div>
                <p class="sub-status">{{ handleStatusChange(dataSource.status) }}</p>
                <div class="row">
                  <div class="col">
                    <div class="label">{{$t('complaintOrderDetail.personCharge')}}：</div>
                    <div class="val">{{ dataSource.serviceUser ? dataSource.serviceUser : '--' }}</div>
                  </div>
                  <div class="col-1">
                    <div class="label">{{$t('editChild.contactNumber')}}：</div>
                    <div class="val">{{ dataSource.servicePhone ? dataSource.servicePhone : '--' }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="label">{{$t('applyChildDetail.updateTime')}}：</div>
                    <div class="val">{{ dataSource.updateTime ? dataSource.updateTime : '--' }}</div>
                  </div>
                </div>
                <div class="btns">


                    <el-button
                    class="contact-btn"
                    v-if="(roleType=='factory'&&dataSource.status==1&&!dataSource.isAssign)||(roleType=='gen'&&dataSource.isAssign&&dataSource.status==1)"
                    @click="confirm('accept')"
                    :loading="acceptLoading"
                    >
                    {{$t('complaintOrderDetail.acceptance')}}
                    </el-button>
                     <el-button
                    class="contact-btn"
                    v-if="roleType!='factory'&&dataSource.status==1"
                    @click="cancel('send')"
                    >
                    {{$t('indexTags.cancel')}}
                    </el-button>
                    <el-button
                    class="contact-btn"
                    v-if="(roleType=='factory')&&dataSource.status==1&&!dataSource.isAssign&&dataSource.source!=1"
                    @click="confirm('send')"
                    >
                    {{$t('complaintOrderDetail.totalAcceptance')}}
                    </el-button>
                </div>
            </div>
        </div>
        <div class="row-box">
            <div class="column-box">
                <div class="topic">
                    <p class="title">{{$t('complaintOrderDetail.detailInfo')}}</p>
                </div>
                <div class="entires">
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('componentsReply.complaintObject')}}</div>
                            <div class="con">{{ dataSource.complaintObject ? dataSource.complaintObject : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('componentsReply.complaintProblem')}}</div>
                            <div class="con">{{ dataSource.complaintIssues ? dataSource.complaintIssues : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('componentsReply.contacts')}}</div>
                            <div class="con">{{ dataSource.linkUser ? dataSource.linkUser : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('componentsReply.contactNumber')}}</div>
                            <div class="con">{{ dataSource.linkPhone ? dataSource.linkPhone : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('deviceListDetail.address')}}</div>
                            <div class="con">{{ dataSource.address ? dataSource.address : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('componentsReply.image')}}</div>
                            <div class="con-1" v-if="dataSource.photo">
                                <div class="image"
                                v-for="(img, idx) in dataSource.photo ? dataSource.photo.split(',') : []"
                                :key="idx"
                                >
                                <el-image
                                    style="width: 100px; height: 100px"
                                    :src="img"
                                    :preview-src-list="[img]">
                                </el-image>
                                </div>
                            </div>
                            <div class="con-1" v-else>
                              - -
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('componentsReply.explain')}}</div>
                            <div class="con">{{ dataSource.remark ? dataSource.remark : '--' }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column-box">
                <div class="topic">
                    <p class="title">{{$t('componentsReply.dealReply')}}</p>
                </div>
                <div class="entires">
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('componentsReply.reply')}}</div>
                            <div class="con">{{ dataSource.reply ? dataSource.reply : '--' }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="label">{{$t('componentsReply.image')}}</div>
                            <div class="con-1" v-if="dataSource.servicePhoto">
                                <div class="image"
                                v-for="(img, idx) in dataSource.servicePhoto ? dataSource.servicePhoto.split(',') : []"
                                :key="idx"
                                >
                                <el-image
                                    style="width: 100px; height: 100px"
                                    :src="img"
                                    :preview-src-list="[img]">
                                </el-image>
                                </div>
                            </div>
                            <div class="con-1" v-else>
                                - -
                            </div>
                        </div>
                    </div>
                    <div class="row">
                    <div class="col">
                        <div class="label">{{$t('componentsReply.enclosure')}}</div>
                        <div class="con" v-if="attachMent">
                            <div class="attach-list">
                                <div class="list-item"
                                v-for="(item, index) in attachMent"
                                :key="index"
                                @click="downloadFile(item)"
                                >
                                    <div class="type">
                                        <img :src="item.resource" alt="" />
                                    </div>
                                    <div class="file-info">
                                        <span class="name">{{ item.name }}</span>
                                        <span class="size">{{ item.size ? item.size : '--' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="con" v-else>
                            - -
                        </div>
                    </div>
                    </div>
                    <div class="btns">
                        <el-button
                        class="contact-btn"
                        v-if="(roleType=='factory'&&dataSource.status==3)||(roleType=='gen'&&dataSource.isAssign&&dataSource.status==2)"
                        @click="showReplyModal"
                        >
                        {{$t('complaintOrderDetail.replyComplaint')}}
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <ReplyModal
    @updateDetail="getDetail"
    :defaultInfo="currentInfo"
    v-if="replyModalVisible"
    :visible.sync="replyModalVisible"
    />
  </div>
</template>

<script>
import { onfileResourceChange, matchFileType, formatByte } from "@/util/fileType"
import {
    shopComplaintdetail,
    areaComplaintdetail,
    generalComplaintdetail,
    shopTranferGen,
    areaTranferGen,
    shopComplaintaccept,
    areaComplaintaccept,
    generalComplaintaccept,
    generalComplaintcancel,
     shopComplaintcancel
    } from "@/api/shopComplain"
import ReplyModal from "./components/modal/complain-reply.vue";
  export default {
    components: {
        ReplyModal
    },
    data() {
      return {
        active: 0,
        attachMent: [],
        dataSource: [],
        detailApi: null, // 详情api
        transferApi: null, // 总代受理api
        acceptApi: null, // 受理api
        loading: false,
        acceptLoading: false,
        replyModalVisible: false,
        roleType: '',
        currentInfo: {},
        stepsList:[
            {name:this.$t('complaintOrderDetail.toBeAccepted'),checkname:this.$t('complaintOrderDetail.accepted'),nowname:this.$t('complaintOrderDetail.toBeAccepted')},
            {name:this.$t('complaintOrderDetail.toBePent'),checkname:this.$t('complaintOrderDetail.pended'),nowname:this.$t('complaintOrderDetail.pending')},
            {name:this.$t('complaintOrderDetail.toBeSured'),checkname:this.$t('complaintOrderDetail.suring'),nowname:this.$t('complaintOrderDetail.toBeSured')},
        ],
      }
    },
    computed: {
        source() {
            if(this.$route.query && this.$route.query.source) {
                return this.$route.query.source.toString();
            }
        },
        id() {
            if(this.$route.query && this.$route.query.id) {
                return this.$route.query.id;
            }
        },
        type() {
            if(this.$route.meta && this.$route.meta.type) {
            return this.$route.meta.type;
            }
        },
        acceptAndSendParams() {
            const _return = {
                processInstanceId: this.dataSource.processInstanceId,
                processDefinitionId: this.dataSource.processDefinitionId,
                businessId: this.dataSource.id,

                flag:"ok"
            }
            return _return
        }
    },
    created() {
        this.getDetail();
        this.roleType = this.website.roleType
    },
    methods: {
        cancel(){
            let obj ={
                    processInstanceId:this.dataSource.processInstanceId,
                    processDefinitionId:this.dataSource.processDefinitionId,
                    businessId:this.dataSource.id,
                   
                    flag:"ok"
                }
            let API = this.roleType==='shop'?shopComplaintcancel:generalComplaintcancel
            API(obj).then(res=>{
                if(res.data.code==200){
                     setTimeout(() => {
                         this.getDetail();
                     })
                }
            })
        },
      // 详情api
      handleDetailApi(e) {
        switch(e) {
            case "1":
                return generalComplaintdetail;
            case "2":
                return areaComplaintdetail;
            case "3":
                return shopComplaintdetail;
        }
      },
      // 转总代api
      handleTransferApi(e) {
        switch(e) {
            case "2":
                return areaTranferGen;
            case "3":
                return shopTranferGen;
        }
      },
      // 受理api
      handleAcceptApi(e) {
        switch(e) {
            case "1":
                return generalComplaintaccept;
            case "2":
                return areaComplaintaccept;
            case "3":
                return shopComplaintaccept;
        }
      },
      handleStatusChange(e) {
         switch(e) {
            case 0:
                return this.$t('complaintOrderDetail.canceled');
            case 1:
                return this.$t('complaintOrderDetail.submitted');
            case 2:
                return this.$t('complaintOrderDetail.totalAccepted');
            case 3:
                return this.$t('complaintOrderDetail.accepted');
            case 4:
                return this.$t('complaintOrderDetail.accepted');
            case 5:
                return this.$t('complaintOrderDetail.replied');
            case 6:
                return this.$t('complaintOrderDetail.completed');
         }
      },
    // 下载附件
      downloadFile(item) {
        console.log('item', item)
        if(!item.url || item.url === 'null') {
            this.$message.error(this.$t('complaintOrderDetail.noEnclosureAddress'));
            return;
        }
        const url = item.url;
        window.open(url);
      },
      attachmentFormatter(arr, arr1, arr2) {
        let nameList = arr && arr.split(",");
        let urlList = arr1 && arr1.split(",");
        // let sizeList = arr2 && arr2.split(",");
        if(nameList.length && urlList.length) {
            let newArr = []
            urlList.map((x, idx) => {
                newArr.push({
                    name: nameList[idx],
                    url: x,
                    resource: onfileResourceChange(matchFileType(nameList[idx])),
                    // size: formatByte(sizeList[idx])
                })
            })
            return newArr;
        }
        console.log('this.attachMent', this.attachMent);
      },
      returnBack() {
         this.$EvenBus.$emit('menuTag', this.$route.fullPath, 'remove');
      },
      showReplyModal() {
         this.replyModalVisible = true;
         this.currentInfo = this.dataSource;
         this.currentInfo.modalType = 'all';
         this.currentInfo.title = this.$t('complaintOrderDetail.replyComplaint');
      },
      confirm(target) {
        let self = this;
        let text = target === 'accept' ? this.$t('complaintOrderDetail.acceptance') : target === 'send' ? this.$t('complaintOrderDetail.totalAcceptance') : '';
        self.$confirm(this.$t('complaintOrderDetail.sureConduct') +`${text}`+this.$t('complaintOrderDetail.isIt')+`?`, this.$t('lockIndex.tip'), {
          confirmButtonText: this.$t('indexTags.sure'),
          cancelButtonText: this.$t('indexTags.cancel'),
          type: 'warning'
        }).then(() => {
          if(target === 'accept') {
            this.accept();
          } else {
            this.send();
          }
        }).catch(() => {});
      },
      // 受理
      async accept() {
         try {
            this.acceptLoading = true;
            this.acceptApi = this.handleAcceptApi(this.source);
            const res = await this.acceptApi(this.acceptAndSendParams);
            console.log('res =>', res.data);
            if(res.data && res.data.code === 200) {
                this.$message.success(this.$t('complaintOrderDetail.acceptSuccess'));
                setTimeout(() => {
                    this.getDetail();
                })
            }
            this.acceptLoading = false;
         } catch(e) {
            this.$message.error(e.toString())
         }
      },
      // 总代受理
      async send() {
        console.log('send', this.source);
        try {
            this.acceptLoading = true;

            this.acceptApi = this.handleTransferApi(this.source);
            const res = await this.acceptApi(this.acceptAndSendParams);
            console.log('res =>', res.data);
            if(res.data && res.data.code === 200) {
                this.$message.success(this.$t('complaintOrderDetail.acceptSuccess'));
                setTimeout(() => {
                    this.getDetail();
                })
            }
            this.acceptLoading = false;
         } catch(e) {
            this.$message.error(e.toString())
         }

      },
      async getDetail() {
        try {
            this.loading = true;
            this.detailApi = this.type === 'all' ? this.handleDetailApi(this.source) : generalComplaintdetail;
            console.log(this.source);
            console.log(this.detailApi);
            const res = await this.detailApi(this.id);
            console.log('res =>', res.data);
            if(res.data && res.data.code === 200) {
                this.dataSource = res.data.data;
                this.attachMent = this.attachmentFormatter(res.data.data.serviceAttachName ? res.data.data.serviceAttachName : '',
                res.data.data.serviceAttach ? res.data.data.serviceAttach : '')
            }
            this.loading = false;
        } catch(e) {
          this.$message.error(e.toString())
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.container {
  background-color: #f0f2f5;
  height: 100%;
  overflow: auto;
}
.main {
  background-color: #fff;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    padding: 0 21px;
    .left {
      display: flex;
      align-items: center;
      .line-1 {
        width: 4px;
        height: 18px;
        background: #01AAA7;
        border-radius: 2px;
      }
      .line-2 {
        margin-left: 2px;
        width: 2px;
        height: 18px;
        background: #01AAA7;
        border-radius: 1px;
      }
      .title {
        margin-left: 9px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }
    .right {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      .back-btn {
        background-color: #01AAA7;
        color: #fff;
      }
    }
  }
  .content {
    padding: 20px 21px;
  }
  .row-box {
   display: flex;
   justify-content: space-between;
   margin-bottom: 20px;
  }
  .column-box {
    flex: 0 0 49%;
    border: 1px solid #E5E5E5;
    .topic {
        display: flex;
        align-items: center;
        padding: 23px 30px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        background-color: #F4F5FA;
        .title-icon {
            color: #50C4CB;
        }
        .title {
            color: #333333;
            margin-left: 12px;
        }
    }
    .entires {
        padding: 20px 95px;
        .row {
        display: flex;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #EEEEEE;;
        }
        .label {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        min-height: 20%;
        }
        .con {
        margin-left: 30px;
        flex: 1;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        }
        .con-1 {
            display: flex;
            align-items: center;
            margin-left: 30px;
            flex: 1;
          }
        .col {
            display: flex;
            align-items: center;
        }
        .attach-list {
            .list-item {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .type {
                    width: 26px;
                    height: 32px;
                    & > img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .file-info {
                    margin-left: 9px;
                    display: flex;
                    flex-direction: column;
                    .name {
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #333333;
                    }
                    .name:hover {
                        text-decoration: underline;
                        color: #1E90FF;
                    }
                    .size {
                        font-size: 12px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #999999;
                    }
                }
            }
            .list-item:hover {
              cursor: pointer;
            }
          }
        .image:not(:first-child) {
            margin-left: 14px;
        }
        .btns {
            margin-top: 57px;
            text-align: center;
            .contact-btn {
                color: #fff;
                background-color: #50C4CB;
            }
        }
    }
    }
    .column-box1 {
        flex: 0 0 49%;
        padding: 45px 0;
        border: 1px solid #E5E5E5;
        .sub-status {
            margin-top: 57px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            text-align: center;
        }
        .row {
            margin-top: 19px;
            display: flex;
            align-content: center;
            justify-content: center;
        }
        .col {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
        }
        .col-1 {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            margin-left: 59px;
            display: flex;
            align-items: center;
        }
        .label {
            min-width: 20%;
        }
        .val {
            flex: 1;
        }
        .btns {
            margin-top: 57px;
            text-align: center;
            .contact-btn {
                color: #fff;
                background-color: #50C4CB;
            }
        }
    }
}
/deep/ .el-step__head.is-finish {
    color: #50C4CB;
    border-color: #50C4CB;
}
/deep/ .el-step__title.is-finish {
    color: #50C4CB;
}
</style>
